import {Button, ListGroup} from "react-bootstrap";
import ListGroupItem from "react-bootstrap/lib/ListGroupItem";
import Form from "react-bootstrap/lib/Form";
import FormGroup from "@mui/material/FormGroup";
import ControlLabel from "react-bootstrap/lib/ControlLabel";
import {Field, reduxForm} from "redux-form";
import {required} from "../../_helpers";
import React from "react";
import {InputTextField} from "../common/formFields/InputTextField";
import styles from "./Styles.module.css"

const FindAndReplaceForm = props => {
    const {handleSubmit, submitButtonText} = props;
    return (
        <ListGroup>
            <ListGroupItem>
                <Form onSubmit={handleSubmit} >
                    <FormGroup>
                        <ControlLabel className={styles.findLabel}>Find</ControlLabel>
                        <Field
                            name="findText"
                            component={InputTextField}
                            type="textArea"
                            placeHolder="Find"
                            className='form-control'
                            useWithRedux={true}
                            outputHtml={true}
                            validateForm={true}
                            validate={required}
                        />
                    </FormGroup>

                    <FormGroup>
                        <ControlLabel className={styles.replaceLabel}>Replace</ControlLabel>
                        <Field
                            name="replacementText"
                            component={InputTextField}
                            type="textArea"
                            placeHolder="Replace"
                            className='form-control'
                            useWithRedux={true}
                            outputHtml={true}
                            validateForm={true}
                            validate={required}
                        />
                    </FormGroup>

                    <FormGroup>
                        <Button type="submit" className={`btn btn-success font-15 ${styles["submitBtn"]}`}>{submitButtonText ? submitButtonText : 'Submit'}</Button>
                    </FormGroup>
                </Form>
            </ListGroupItem>
        </ListGroup>
    )
}
const connectedComponent = reduxForm({
    form: 'findAndReplaceForm'
})(FindAndReplaceForm);

export {connectedComponent as FindAndReplaceForm}
